import { Search, Download, Filter, Calendar } from "lucide-react";
function Reports() {
  const reports = [
    { id: 1, name: "Revenue by Client", type: "Financial", period: "March 2026", lastRun: "2026-03-06 09:30", format: "PDF" },
    { id: 2, name: "Invoice Aging Report", type: "AR", period: "Q1 2026", lastRun: "2026-03-06 08:15", format: "Excel" },
    { id: 3, name: "Activity Hours Summary", type: "Operations", period: "March 2026", lastRun: "2026-03-05 16:45", format: "PDF" },
    { id: 4, name: "Client Profitability Analysis", type: "Financial", period: "Q1 2026", lastRun: "2026-03-05 14:20", format: "Excel" },
    { id: 5, name: "GL Account Summary", type: "Accounting", period: "March 2026", lastRun: "2026-03-04 11:00", format: "PDF" },
    { id: 6, name: "Cost Center Allocation", type: "Accounting", period: "March 2026", lastRun: "2026-03-04 10:30", format: "Excel" },
    { id: 7, name: "Monthly Billing Summary", type: "Financial", period: "February 2026", lastRun: "2026-03-01 09:00", format: "PDF" },
    { id: 8, name: "Contract Rate Analysis", type: "Operations", period: "Q1 2026", lastRun: "2026-02-28 15:45", format: "Excel" }
  ];
  return <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Reports</h1>
        <p className="text-gray-600 dark:text-gray-400">Generate and access financial and operational reports</p>
      </div>

      {
    /* Search and Filters */
  }
      <div className="mb-6 flex items-center justify-between">
        <div className="flex gap-4 flex-1">
          <div className="relative flex-1 max-w-md">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
    type="text"
    placeholder="Search reports..."
    className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100"
  />
          </div>
          <select className="px-4 py-2 border border-gray-300 dark:border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
            <option>All Types</option>
            <option>Financial</option>
            <option>Operations</option>
            <option>Accounting</option>
            <option>AR</option>
          </select>
          <button className="app-btn-gloss">
            <Calendar className="w-5 h-5 text-blue-600 dark:text-blue-400" />
            Date Range
          </button>
        </div>
        <button className="app-btn-gloss ml-4">
          <Filter className="w-5 h-5" />
          Custom Report
        </button>
      </div>

      {
    /* Reports Table */
  }
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 dark:bg-gray-800">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Report Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Type</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Period</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Last Run</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Format</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-700 dark:text-gray-300 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-800">
              {reports.map((report) => <tr key={report.id} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                  <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-gray-100">{report.name}</td>
                  <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">{report.type}</td>
                  <td className="px-6 py-4 text-sm text-gray-900 dark:text-gray-100">{report.period}</td>
                  <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">{report.lastRun}</td>
                  <td className="px-6 py-4 text-sm">
                    <span className="px-2 py-1 rounded text-xs bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100">
                      {report.format}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <button className="app-btn-plain inline-flex items-center gap-1 px-3 py-1 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors">
                      <Download className="w-4 h-4 text-blue-600 dark:text-blue-400" />
                      Download
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {
    /* Quick Reports */
  }
      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-4">Quick Reports</h2>
        <div className="grid grid-cols-3 gap-6">
          <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 p-6 rounded hover:shadow-md transition-shadow cursor-pointer">
            <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">Current Month Summary</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">View all activity for the current billing period</p>
            <button className="app-btn-gloss text-sm">Generate →</button>
          </div>
          <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 p-6 rounded hover:shadow-md transition-shadow cursor-pointer">
            <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">Outstanding Invoices</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">List of all unpaid and overdue invoices</p>
            <button className="app-btn-gloss text-sm">Generate →</button>
          </div>
          <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 p-6 rounded hover:shadow-md transition-shadow cursor-pointer">
            <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">Client Activity Report</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">Detailed breakdown by client and jacket</p>
            <button className="app-btn-gloss text-sm">Generate →</button>
          </div>
        </div>
      </div>
    </div>;
}
export {
  Reports
};
